
import { IAPIJobForRecruiter, IAPIPackageVariant } from '@hokify/common';
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { piniaAvailable } from '../helpers/piniaStoreAvailable';
import PricePackageCollapsible from './PricePackageCollapsible.vue';
import { getSupportPhone } from '../helpers/contact-info';
import { trialPackages, cpaPackages, ICustomPackage } from '../data/custom-packages-de';

export default defineComponent({
	name: 'PricePackageContainer',
	components: { PricePackageCollapsible },
	data() {
		return {
			tooltipText: '',
			tooltipHeadline: '',
			modalShown: false,
			selectedContingent: 1,
			supportPhone: getSupportPhone(
				piniaAvailable(this.$nuxt, '$userRootStore')
					? this.$nuxt.context.$userRootStore?.topLevelDomain
					: this.$store.state.topLevelDomain
			),
			piniaAvailable
		};
	},
	computed: {
		topLevelDomain(): string | undefined {
			return piniaAvailable(this.$nuxt, '$userRootStore')
				? this.$nuxt.context.$userRootStore?.topLevelDomain
				: this.$store?.state?.topLevelDomain;
		},
		showContingentSelection(): boolean {
			return !this.switchPackage && this.packages?.some(p => p.contingentDiscounts?.length);
		},
		sortedPackages(): IAPIPackageVariant[] {
			const sortedPackages = this.packages.slice(0);
			return sortedPackages.sort((a, b) => a.price - b.price);
		},
		switchPackage(): boolean {
			return !!this.job;
		},
		packageCollection(): (ICustomPackage[] | IAPIPackageVariant[])[] {
			return [cpaPackages, this.sortedPackages, trialPackages];
		}
	},
	methods: {
		sanitizeInput() {
			if (this.selectedContingent <= 0) {
				this.selectedContingent = 1;
			} else if (this.selectedContingent > 10) {
				this.selectedContingent = 10;
				this.$emit('show-modal');
				this.modalShown = true;
			}
			this.handleContingentSelection(this.selectedContingent);
		},
		increaseContingentSelection() {
			if (this.selectedContingent === 10) {
				this.$emit('show-modal');
				this.modalShown = true;
			} else {
				this.selectedContingent += 1;
			}
			this.handleContingentSelection(this.selectedContingent);
		},
		decreaseContingentSelection() {
			this.selectedContingent -= 1;
			this.handleContingentSelection(this.selectedContingent);
		},
		handleContingentSelection(contingent: number) {
			this.$emit('select-contingent', contingent);
		},
		openTooltip(text, headline) {
			if (text.length === 0) return;
			this.tooltipHeadline = headline;
			this.tooltipText = text;
			this.$modal.show('tooltip', text);
		},
		disabledButton(component: string): boolean {
			if (component === 'add') {
				return this.modalShown && this.selectedContingent === 10;
			}
			if (component === 'remove') {
				return this.selectedContingent === 1;
			}
			return false;
		}
	},
	props: {
		packages: { type: Array as PropType<IAPIPackageVariant[]>, required: true },
		buttonText: { type: String, required: false, default: 'Inserat erstellen' },
		appendCustomFeatures: { type: Boolean, default: true },
		job: { type: Object as PropType<IAPIJobForRecruiter> },
		isCompanyApp: { type: Boolean, default: false }
	}
});
